import CompaniesBasicRequest from '../ws/CompaniesBasicRequest';

export const COMPANIES_AUTOCOMPLETE_UPDATE = 'companies-autocomplete-update';
export const COMPANIES_AUTOCOMPLETE_LOADING = 'companies-autocomplete-loading';

export const getCompanies = (id, search = '', onlyActive = false) => (dispatch) => {

    new CompaniesBasicRequest(search, onlyActive)
        .onPreExecution(() => {
            dispatch({
                type: COMPANIES_AUTOCOMPLETE_LOADING,
                id: id,
                payload: true,
            });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: COMPANIES_AUTOCOMPLETE_UPDATE,
                id: id,
                payload: response,
            });
        })
        .onPostExecution(() => {
            dispatch({
                type: COMPANIES_AUTOCOMPLETE_LOADING,
                id: id,
                payload: false,
            });
        })
        .execute();

};



// WEBPACK FOOTER //
// ./src/app/company/actions/companyAutocompleteActions.js